import { createRoute } from '@tanstack/react-router'

import OrderRedirectPage from '../pages/OrderRedirectPage'
import { orderRoute } from './OrderRoute'

export const orderGuestRedirectCreateRoute = createRoute({
  getParentRoute: () => orderRoute,
  component: () => <OrderRedirectPage />,
  path: '/guest'
})
